export default __webpack_public_path__ + "static/media/youtube.becde3a1.svg";